import type { Scene } from '@/types';

/**
 * Registro central de todas las escenas. Las escenas se registran
 * por módulo de contenido y se consultan por id.
 */

const registro = new Map<string, Scene>();

export function registrarEscenas(escenas: readonly Scene[]): void {
  for (const escena of escenas) {
    if (registro.has(escena.id)) {
      throw new Error(`Escena duplicada: "${escena.id}"`);
    }
    registro.set(escena.id, escena);
  }
}

export function obtenerEscena(id: string): Scene | undefined {
  return registro.get(id);
}

export function escenaRequerida(id: string): Scene {
  const e = registro.get(id);
  if (!e) throw new Error(`Escena no registrada: "${id}"`);
  return e;
}

/** Útil para tests y para la pantalla de menú (contar progreso). */
export function todasLasEscenas(): Scene[] {
  return Array.from(registro.values());
}

/** Solo para tests: limpia todo el registro. */
export function _limpiarRegistro(): void {
  registro.clear();
}
